<div class="content-wrapper table-full-bx users">
  <div class="page-content recruiterpanel">
      <div class="row">
          <!-- Active users -->
          <div class="col-lg-12">
              <div class="ibox">
                  <div class="ibox-body">
                    <div class="iboxcontent">
                        <h3 class="headingTab"> My Candidates </h3>
                    </div>
                      <!-- tabs -->
                      <ul class="nav nav-pills job-list mt-0">
                          <li class="active">
                              <a href="javascript:void(0)">Favourite candidates</a>
                          </li>
                          <li>
                              <a href="javascript:void(0)" routerLink="/candidates/skipped">Skipped candidates</a>
                          </li>
                      </ul> 
                      <!-- searchbox -->
                      <div class="flexbox">
                          <div class="iboxcontent">
                              <h3>  </h3>
                          </div>
                          <div class="input-group-icon input-group-icon-left">
                              <div class="col-list-right">
                                  <form (ngSubmit)="searchFun()">
                                      <div class="form-group">
                                          <span class="input-icon input-icon-right font-16" (click)="searchFun()"><img src="assets/images/search.svg"></span>
                                          <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid search" name="search" id="key-search" placeholder="Search Name, Title & Last Company" />
                                          <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                                      </div>
                                  </form>
                              </div> 
                          </div>
                      </div>
                      <!-- end -->
                      <!-- Table -->
                      <div class="table-scroll table-wrapper user-top table-responsive">
                          <table id="example" class="table table-bordered  table-hover m-0" style="width: 100%;">
                              <thead>
                                  <tr>
                                      <th class="width-auto">Name</th>
                                      <th>Title</th>
                                      <th>Last company</th>
                                      <th>Last activity</th>
                                      <th>Marked favorite on</th>
                                      <th>Action</th>
                                  </tr>
                              </thead>

                              <tbody>
                                  <!-- 1 -->
                                  <tr *ngFor="let data of usersData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                                      <td class="td-linked"> 
                                          <a (click)="redirectTo(data)"><img class="rounded-circle" [src]="data?.user?.profileImage != null ? globalUrl + data?.user?.profileImage :'../../../assets/images/profile-img.jpg' "/> <span class="text-orange">{{data?.user?.name}} </span>  
                                            <span class="ms-2" *ngIf="totalExperience != null"> ({{totalExperience(data)}})</span>
                                          </a> 
                                      </td>
                                      <td><a (click)="redirectTo(data)">
                                        <span class="industryName" *ngFor="let exp of data?.user?.user_work_experiences;let i=index;">{{exp?.jobTitle != null ? exp?.jobTitle : "-"}}</span>
                                         </a></td>
                                      <td><a (click)="redirectTo(data)">
                                        <span *ngFor="let expName of data?.user?.user_work_experiences;let i=index;let Last=last;">{{expName?.companyName}}{{!Last?',':''}}</span></a></td> 
                                      <td><a (click)="redirectTo(data)">{{data?.updatedAt | date: "d/M/YYYY"}}</a></td> 
                                      <td><a (click)="redirectTo(data)">{{data?.updatedAt | date: "d/M/YYYY h:mm a"}}</a></td> 
                                      <td>
                                        <div class="action-wrap table-action">
                                          <a href="javascript:void(0)" (click)="updateStatus(data)">Remove</a> 
                                        </div>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>

                          <div class="noDataFound" *ngIf="usersData.length == 0">
                              <h2>No Records Found</h2>
                          </div>
                      </div>
                      <!-- end -->
                      <!--  pagination  -->
                      <div class="col-sm-12 p-0" *ngIf="totalCount > 9">
                          <ul class="pagination ">
                              <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                          </ul>
                      </div>
                  </div>
              </div>
          </div> 
      </div>
  </div>
</div>